import { Message } from "../../store/slices/ClimateAssistantSlice";
import { formatDayTime } from "../../utils/dateFormatter";

type MessageFlags = {
  hasError?: boolean;
  isNewSession?: boolean;
  isAiAnalysis?: boolean;
  kpiName?: string;
};

export const generateMessage = (
  user: string,
  text: string,
  flags: MessageFlags = {}
) => {
  const {
    hasError = false,
    isNewSession = false,
    isAiAnalysis = false,
    kpiName = "",
  } = flags;

  return {
    requestId: "",
    sessionId: "",
    sender: user,
    dateTime: formatDayTime(),
    hasError: hasError,
    showNewSession: isNewSession,
    isAiAnalysis,
    kpiName,
    data: {
      text: text,
      graph: {
        chart_type: "",
        title: "",
        description: "",
        data: {},
        sql_query: "",
      },
      table: {
        show_table: false,
        show_csv: false,
      },
      graphSQLData: [],
      tableSQLData: [],
      csv: "",
    },
  };
};

const formatLabel = (key: string): string => {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};

export const generateColumns = (data: any[]) => {
  if (!data || data.length === 0 || !data[0]) return [];

  return Object.keys(data[0]).map((key) => {
    const sampleValue = (data[0] as any)[key];
    const isNumeric = typeof sampleValue === "number";

    return {
      key: key,
      label: formatLabel(key),
      numeric: isNumeric,
      width: isNumeric ? 180 : 250,
    };
  });
};

export const extractLastBotSQL = (messages: Message[]): string => {
  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages[i];

    if (msg.sender === "bot") {
      const sql = msg.data?.graph?.sql_query;
      return sql && typeof sql === "string" && sql.trim() !== "" ? sql : "";
    }
  }

  return "";
};
